import Slider from "./offer/slider";
import Offertenav from "./offer/offertenav"
require('./bootstrap');

new Offertenav();
new Slider();
